// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring/Content/Unstarted/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_DentalMonitoring_Content_Unstarted($id: uuid!) {
  dental_monitoring_patient_quickstarts(id: $id) {
    id
    quickstarts {
      limit
      cursor {
        before
        after
      }
      items {
        quickstart_id
        monitoring_config {
          protocol_title
        }
      }
    }
  }
}

`